import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import Managebtn from "../../../Component/Managebtn";
import HttpClient from "../../../utils/HttpClient";
import DashboardChartOne from "./DashboardChartOne";
import DashboardChartThree from "./DashboardChartThree";
import DashboardChartTwo from "./DashboardChartTwo";
import { FcPrevious, FcNext } from "react-icons/fc";
import DashboardChartFive from "./DashboardChartFive";
import DashboardChartFour from "./DashboardChartFour";
import DashboardChartSix from "./DashboardChartSix";
import DashboardChartSeven from "./DashboardChartSeven";
import { useLocation, useNavigate } from "react-router-dom";
import dashboard_en_1 from "../../../Audio_files/VI. Project Manager Audio/VI. b. View Project Performance/vi_view_project_performance_audio_a.mp3";
import dashboard_es_1 from "../../../spanish_audio_files/VI. Project Manager Audio/VI. b. View Project Performance/vi_view_project_performance_audio_a_es.mp3";
import dashboard_en_2 from "../../../Audio_files/VII. Dashboard Manager Audio/VII. a. View Dashboards/vii_view_dashboards_audio_a.mp3";
import dashboard_es_2 from "../../../spanish_audio_files/VII. Dashboard Manager Audio/VII. a. View Dashboards/vii_view_dashboards_audio_a_es.mp3";
import { useLanguage } from "../../../Providers/LanguageContext";
import { SpeechContext } from "../../../Providers/SpeechWrapper";
import { UserContext } from "../../../Providers/UserWrapper";
// import DashBoardZero from "./DashBoardZero";
import "./toolip.css";
import DashboardChartSixB from "./DashboardChartSixB";
import IntegrationBankDeailModal from "../../../Modal/IntegrationBankDeailModal";
import Dashboardzerotwo from "./Dashboardzerotwo";
import hamburger from "../../../images/hamburger.png";
import AnimatedLineChart from "./AnimatedLineChart/AnimatedLineChart";
import LineChartTwo from "./LineChartTwo/LineChartTwo";
import LineChartThree from "./LineChartThree/LineChartThree";
import { useSelector } from "react-redux";

function DashboardManager7() {
  const {
    openAccReceive7,
    expensePerLineGraph7,
    expensePerBarGraph7,
    expenseBarChart7,
    salesLineChart7,
    expenseLineChart7,
    profitLineChart7,
    currentTotalBar7,
    currentTotalLine7,
    currentActualVsBudgetBar7,
    currentActualVsBudgetLine7,
    balanceDashboard7,
    transactionDashboard7,
    taxPieGraph7,
    taxLineGraph7,
  } = useSelector((state) => state?.favDashboard);
  const location = useLocation();
  const { language, currentLanguage } = useLanguage();
  const navigate = useNavigate();
  // console.log("4f5dg4561", location);
  const slideRef = useRef();
  const { setShowGif, setGifToShow, setGifPoints } = useContext(SpeechContext);
  const { currAudio, setCurrAudio, playing } = useContext(SpeechContext);
  const { profileData, isBusiness, isInvestor, isBookKeeper } =
    useContext(UserContext);
  const [isToggle, setIsToggle] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const [transData, setTransData] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);

  // console.log("locationd", location);

  // console.log("pathname", location.pathname)
  const [time, setTime] = useState("day");
  const [zeroDate, setZeroDate] = useState({
    startDate: "",
    endDate: "",
  });

  const [dashboardOneData, setDashboardOneData] = useState([]);
  const [dashboardTwoData, setDashboardTwoData] = useState([]);
  const [dashboardThreeData, setDashboardThreeData] = useState([]);
  const [dashboardZeroData, setDashbardZeroData] = useState({});
  const [dashBoardZeroTaskData, setDashBoardZeroTaskData] = useState({});
  const [selectedTwo, setSelectedTwo] = useState({
    day: "",
    week: "",
    month: "",
    year: "",
  });

  const [selectedOne, setSelectedOne] = useState({
    day: "",
    week: "",
    month: "",
    year: "",
  });

  // console.log("locationdasff", location)

  const getTime = (val) => {
    setTime(val);
    setZeroDate({
      startDate: "",
      endDate: "",
    });
  };

  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "instant" });
  }, []);

  const [dashboardOneData2, setDashboardOneData2] = useState([]);
  const [dashboardTwoData2, setDashboardTwoData2] = useState([]);

  // dashboard one data fetch
  const fetchDashboardOne = async () => {
    if (profileData) {
      // if (profileData.userType === "Business") {
      let res = {};
      if (isInvestor || isBookKeeper) {
        if (
          selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.month?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-one-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              day: selectedOne.day,
            }
          );
        } else if (
          selectedOne.week?.length &&
          !selectedOne.day?.length &&
          !selectedOne.month?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-one-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              week: selectedOne.week,
            }
          );
        } else if (
          selectedOne.month?.length &&
          !selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-one-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              month: selectedOne.month,
            }
          );
        } else if (
          selectedOne.year?.length &&
          !selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.month?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-one-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              year: selectedOne.year,
            }
          );
        } else {
          if (
            selectedOne?.day?.length &&
            !selectedOne?.week?.length &&
            !selectedOne?.month?.length &&
            !selectedOne?.year?.length
          ) {
            res = await HttpClient.requestData(
              "investor/investor-dashboard-one-view/" +
                location?.state?.userRegCodr,
              "POST",
              { dayType: time, day: selectedOne.day }
            );
          } else if (
            selectedOne?.week?.length &&
            !selectedOne?.day?.length &&
            !selectedOne?.month?.length &&
            !selectedOne?.year?.length
          ) {
            res = await HttpClient.requestData(
              "investor/investor-dashboard-one-view/" +
                location?.state?.userRegCodr,
              "POST",
              { dayType: time, week: selectedOne.week }
            );
          } else if (
            selectedOne?.month?.length &&
            !selectedOne?.day?.length &&
            !selectedOne?.week?.length &&
            !selectedOne?.year?.length
          ) {
            res = await HttpClient.requestData(
              "investor/investor-dashboard-one-view/" +
                location?.state?.userRegCodr,
              "POST",
              { dayType: time, month: selectedOne.month }
            );
          } else if (
            selectedOne?.year?.length &&
            !selectedOne?.day?.length &&
            !selectedOne?.week?.length &&
            !selectedOne?.month?.length
          ) {
            res = await HttpClient.requestData(
              "investor/investor-dashboard-one-view/" +
                location?.state?.userRegCodr,
              "POST",
              { dayType: time, year: selectedOne.year }
            );
          } else {
            res = await HttpClient.requestData(
              "investor/investor-dashboard-one-view/" +
                location?.state?.userRegCodr,
              "POST",
              { dayType: time }
            );
          }
        }
      } else if (profileData.userType === "Business") {
        if (
          selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.month?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-view", "POST", {
            dayType: time,
            day: selectedOne.day,
          });
        } else if (
          selectedOne.week?.length &&
          !selectedOne.day?.length &&
          !selectedOne.month?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-view", "POST", {
            dayType: time,
            week: selectedOne.week,
          });
        } else if (
          selectedOne.month?.length &&
          !selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-view", "POST", {
            dayType: time,
            month: selectedOne.month,
          });
        } else if (
          selectedOne.year?.length &&
          !selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.month?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-view", "POST", {
            dayType: time,
            year: selectedOne.year,
          });
        } else {
          res = await HttpClient.requestData("dasbord-one-view", "POST", {
            dayType: time,
          });
        }
      } else if (profileData.userType === "Personal") {
        if (
          selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.month?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-pu-view", "POST", {
            dayType: time,
            day: selectedOne.day,
          });
        } else if (
          selectedOne.week?.length &&
          !selectedOne.day?.length &&
          !selectedOne.month?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-pu-view", "POST", {
            dayType: time,
            week: selectedOne.week,
          });
        } else if (
          selectedOne.month?.length &&
          !selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.year?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-pu-view", "POST", {
            dayType: time,
            month: selectedOne.month,
          });
        } else if (
          selectedOne.year?.length &&
          !selectedOne.day?.length &&
          !selectedOne.week?.length &&
          !selectedOne.month?.length
        ) {
          res = await HttpClient.requestData("dasbord-one-pu-view", "POST", {
            dayType: time,
            year: selectedOne.year,
          });
        } else {
          res = await HttpClient.requestData("dasbord-one-pu-view", "POST", {
            dayType: time,
          });
        }
      }
      if (res && res.status) {
        if (
          res.message &&
          res.message.trim() === "Dashboard rewards 1 points"
        ) {
          setShowGif(true);
          setGifToShow("Dashboard rewards 1 points");
          setGifPoints(1);
        }
        const fixedData = FixedTwoDecimal(res.data);
        setDashboardOneData(fixedData);
        setDashboardOneData2(res.data2);
      }

      // else {
      //   const res = await HttpClient.requestData(
      //     "dasbord-one-pu-view",
      //     "POST",
      //     { dayType: time }
      //   );
      //   // console.log("dasbordonepu", res);
      //   if (res && res.status) {
      //     if (
      //       res.message &&
      //       res.message.trim() === "Dashboard rewards 1 points"
      //     ) {
      //       setShowGif(true);
      //       setGifToShow("Dashboard rewards 1 points");
      //       setGifPoints(1);
      //     }
      //     const fixedData = FixedTwoDecimal(res.data);
      //     setDashboardOneData(fixedData);
      //   }
      // }
    }
  };

  const fetchDashboardThreeData = async () => {
    if (profileData) {
      let res = {};
      if (profileData.userType === "Business") {
        res = await HttpClient.requestData("dashboard-three-view", "POST", {
          dayType: time,
        });
      } else if (profileData.userType === "Personal") {
        res = await HttpClient.requestData("dashboard-three-pu-view", "POST", {
          dayType: time,
        });
      } else if (isInvestor || isBookKeeper) {
        res = await HttpClient.requestData(
          "investor/investor-dashboard-three-view/" +
            location?.state?.userRegCodr,
          "POST",
          { dayType: time }
        );
      }
      if (res && res.status) {
        if (
          res.message &&
          res.message.trim() === "Dashboard rewards 1 points"
        ) {
          setShowGif(true);
          setGifToShow("Dashbord rewards 1 points");
          setGifPoints(1);
        }
        setDashboardThreeData(res.data);
      }
      // }
      // else {
      //   const res = await HttpClient.requestData(
      //     "dashboard-three-pu-view",
      //     "POST",
      //     { dayType: time }
      //   );
      //   // console.log("dasbordthreepu", res);
      //   if (res && res.status) {
      //     if (
      //       res.message &&
      //       res.message.trim() === "Dashboard rewards 1 points"
      //     ) {
      //       setShowGif(true);
      //       setGifToShow("Dashbord rewards 1 points");
      //       setGifPoints(1);
      //     }
      //     setDashboardThreeData(res.data);
      //   }
      // }
    }
  };
  // console.log("selectedTwo: ", selectedTwo);

  // dashboard data fetch
  const fetchDashboardTwoData = async () => {
    if (profileData) {
      let res = {};
      if (profileData.userType === "Business") {
        // console.log('timetwo',time)
        if (
          selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.month?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-view", "POST", {
            dayType: time,
            day: selectedTwo.day,
          });
        } else if (
          selectedTwo.week?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.month?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-view", "POST", {
            dayType: time,
            week: selectedTwo.week,
          });
        } else if (
          selectedTwo.month?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-view", "POST", {
            dayType: time,
            month: selectedTwo.month,
          });
        } else if (
          selectedTwo.year?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.month?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-view", "POST", {
            dayType: time,
            year: selectedTwo.year,
          });
        } else {
          res = await HttpClient.requestData("dashboard-two-view", "POST", {
            dayType: time,
          });
        }
      } else if (profileData.userType === "personal") {
        if (
          selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.month?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-pu-view", "POST", {
            dayType: time,
            day: selectedTwo.day,
          });
        } else if (
          selectedTwo.week?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.month?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-pu-view", "POST", {
            dayType: time,
            week: selectedTwo.week,
          });
        } else if (
          selectedTwo.month?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-pu-view", "POST", {
            dayType: time,
            month: selectedTwo.month,
          });
        } else if (
          selectedTwo.year?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.month?.length
        ) {
          res = await HttpClient.requestData("dashboard-two-pu-view", "POST", {
            dayType: time,
            year: selectedTwo.year,
          });
        } else {
          res = await HttpClient.requestData("dashboard-two-pu-view", "POST", {
            dayType: time,
          });
        }
      } else if (isInvestor || isBookKeeper) {
        if (
          selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.month?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-two-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              day: selectedTwo.day,
            }
          );
        } else if (
          selectedTwo.week?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.month?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-two-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              week: selectedTwo.week,
            }
          );
        } else if (
          selectedTwo.month?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.year?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-two-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              month: selectedTwo.month,
            }
          );
        } else if (
          selectedTwo.year?.length &&
          !selectedTwo.day?.length &&
          !selectedTwo.week?.length &&
          !selectedTwo.month?.length
        ) {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-two-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
              year: selectedTwo.year,
            }
          );
        } else {
          res = await HttpClient.requestData(
            "investor/investor-dashboard-two-view/" +
              location?.state?.userRegCodr,
            "POST",
            {
              dayType: time,
            }
          );
        }
      }
      // console.log("dasbordtwobu", res);
      if (res && res.status) {
        if (
          res.message &&
          res.message.trim() === "Dashboard rewards 1 points"
        ) {
          setShowGif(true);
          setGifToShow("Dashboard rewards 1 points");
          setGifPoints(1);
        }
        const fixedData = FixedTwoDecimal(res.data);
        setDashboardTwoData(fixedData);
        setDashboardTwoData2(res.data2);
      }
      // }

      // else {
      //   const res = await HttpClient.requestData(
      //     "dashboard-two-pu-view",
      //     "POST",
      //     { dayType: time }
      //   );
      //   console.log("dasbordtwopu", res);
      //   if (res && res.status) {
      //     if (
      //       res.message &&
      //       res.message.trim() === "Dashboard rewards 1 points"
      //     ) {
      //       setShowGif(true);
      //       setGifToShow("Dashboard rewards 1 points");
      //       setGifPoints(1);
      //     }
      //     let obj = {
      //       Expense: Number(res.data.Expense).toFixed(2),
      //       ExpenseBudget: Number(res.data.ExpenseBudget).toFixed(2),
      //     };
      //     // console.log("obj", obj)
      //     setDashboardTwoData(obj);
      //   }
      // }
    }
  };

  // fixed value in to decimal from an object
  const FixedTwoDecimal = (obj) => {
    Object.keys(obj).forEach((key) => {
      obj[key] = Number.isInteger(Number(obj[key]))
        ? Number(obj[key])
        : Number(obj[key])?.toFixed(2);
    });
    return obj;
  };

  const isDtaeMemo = useMemo(() => {
    if (time && !zeroDate.startDate && !zeroDate.endDate) {
      return true;
    } else if (!time && zeroDate.startDate && zeroDate.endDate) {
      return true;
    } else {
      return false;
    }
  }, [zeroDate, time]);

  // **********************dashboard zero *************************

  const fetchDashBoardZeroData = async () => {
    const sendData = {
      // dayType: time,
      // startDate: zeroDate.startDate,
      // endDate: zeroDate.endDate,

      input_type: "",
      input_name: "",
      dayType: time,
      startAR: "",
      endAR: "",
    };

    // console.log("sendData", sendData, isInvestor)

    // if (isDtaeMemo) {
    // if (isBusiness) {
    let res = null;
    if (isInvestor || isBookKeeper) {
      res = await HttpClient.requestData(
        "investor/investor-dashboard-zero-view/" + location?.state?.userRegCodr,
        "POST",
        sendData
      );
    } else {
      res = await HttpClient.requestData("dashboard-zero-bu", "POST", sendData);
    }

    console.log("resszero", res);
    if (res && res.status) {
      let obj2 = FixedTwoDecimal(res.data);
      setDashbardZeroData(obj2);
    }
    // }
    // else {
    //   const res = await HttpClient.requestData(
    //     "dashboard-zero-pu",
    //     "POST",
    //     sendData
    //   );
    //   if (res && res.status) {
    //     let obj2 = FixedTwoDecimal(res.data);
    //     setDashbardZeroData(obj2);
    //   }
    // }
    // }
  };

  const fetchDashboardZeroTask = async () => {
    const data = {
      dayType: "month",
    };
    const res = await HttpClient.requestData(
      "dashboard-zero-view-countaksevent",
      "POST",
      data
    );
    // console.log("ressDDd", res);
    if (res && res?.status) {
      setDashBoardZeroTaskData(res?.data);
    } else {
    }
  };

  useEffect(() => {
    fetchDashBoardZeroData();
    fetchDashboardZeroTask();
  }, [profileData, time, location?.state?.userRegCodr]);
  // ********************** end dashboard zero **************************

  useEffect(() => {
    fetchDashboardOne();
    fetchDashboardThreeData();
    fetchDashboardTwoData();
  }, [
    time,
    profileData,
    isInvestor,
    isBookKeeper,
    location?.state?.userRegCodr,
    selectedTwo,
    selectedOne,
  ]);

  // returns the slide no for initial slide
  const getInitialSlideMemo = useMemo(() => {
    if (location.pathname === "/project-performance") return 2;
    else if (location?.state?.slideNo === 5) {
      getTime("month");
      if (isBusiness) return 5;
      else return 4;
    } else if (location?.state?.slideNo === 6) {
      getTime("month");
      if (isBusiness) return 6;
      else return 5;
    } else if (location?.state?.slideNo === 7) {
      // getTime("month");
      if (isBusiness) return 7;
      else return 6;
    }

    // else if (location.pathname === "/dashboard-manager") return 5;
    else return 0;
  }, [location]);

  // for sliders
  const settings = {
    dots: false,
    infinite: false,
    draggable: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // initialSlide: location.pathname === "/project-performance" ? 2 : 0,
    initialSlide: getInitialSlideMemo,
    // nextArrow:<FcNext />,
    // prevArrow:<FcPrevious />
  };

  const goToSelectedSlice = (n) => {
    slideRef.current.slickGoTo(n);
  };

  useEffect(() => {
    if (playing) {
      if (currAudio) {
        if (!currAudio.paused) {
          currAudio.pause();
        }
      }
      if (currentLanguage === "eng") {
        if (location.pathname === "/project-performance") {
          setCurrAudio(new Audio(dashboard_en_1));
        } else {
          setCurrAudio(new Audio(dashboard_en_2));
        }
      } else {
        if (location.pathname === "/project-performance") {
          setCurrAudio(new Audio(dashboard_es_1));
        } else {
          setCurrAudio(new Audio(dashboard_es_2));
        }
      }
    } else {
      if (currAudio) {
        if (!currAudio.paused) {
          currAudio.pause();
          setCurrAudio(null);
        }
      }
    }

    return () => {
      if (currAudio && !currAudio.paused) {
        currAudio.pause();
      }
    };
  }, [playing, currentLanguage]);

  // useEffect(() => {
  //   console.log("currAudio", currAudio)
  //   if (currAudio) {
  //     if (!currAudio.paused) {
  //       currAudio.pause()
  //     }
  //     currAudio.play()
  //   }
  //   return () => {
  //     if (currAudio && !currAudio.paused) {
  //       currAudio.pause()
  //     }
  //   }
  // }, [currAudio])

  const handleViewAllBalance = () => {
    if (slideRef.current) {
      slideRef.current.slickGoTo(5);
      setTimeout(() => setIsToggle(true), 300); // Delay to ensure slide transition
    }
  };

  const handleViewAllTransaction = () => {
    if (slideRef.current) {
      slideRef.current.slickGoTo(6);
      setTimeout(() => setIsToggle(false), 300); // Delay to ensure slide transition
    }
  };

  useEffect(() => {
    if (location?.state?.slideNo === 5) {
      setIsToggle(true);
    } else {
      setIsToggle(false);
    }
  }, [location?.state?.slideNo]);

  // console.log("expensePerLineGraph7:>>>> ", expensePerLineGraph7);

  console.log("Redux state in DashboardChartFourColumn:", {
    expenseBarChart7,
    salesLineChart7,
    expenseLineChart7,
    profitLineChart7,
    openAccReceive7,
    expensePerLineGraph7,
    expensePerBarGraph7,
  });

  return (
    <div
      className="dashboard_manager"
      style={{
        background: "linear-gradient( rgb(255, 255, 255),rgba(15, 36, 55, 1))",
        padding: "20px 0px",
      }}
      onClick={() => setDetailModal(false)}
    >
      {/* <div className="try_fisibilty_wrapper " style={{
        transform: 'translateY(0%)',
        margin: '0px',
        justifyContent: 'start',
        background: '#031f31ff'

      }}>
        <div className="container-fluid">
          <p className="text-left">Dashboard Manager / Dashboard</p> </div>
      </div> */}
      {/* {location?.pathname === "/project-performance" && <div className=''>
        <button className='w-25 mb-2 btn btn-outline-success' style={{ fontWeight: "bold", margin: "0 0 0 120px" }} onClick={() => navigate('/project-budget-setup')}>
          {language.setup_pro_budget}
        </button>
      </div>} */}
      {/* {location?.pathname === "/dashboard-manager" && location?.state?.slideNo === 7 &&
        <div className='d-flex gap-2 mb-2' style={{ margin: "0 0 0 154px" }}>
          <div className=''>
            <button className='w-100 btn btn-outline-success' style={{ fontWeight: "bold" }} onClick={() => navigate('/bookkeper')}>{language.add_virtual_bookkeper}</button>
          </div>

          <div className=''>
            <button className='w-100 btn btn-outline-success' style={{ fontWeight: "bold" }}
              onClick={() => navigate('/bookKeperDocs')}
            >
              {language.view_upload_docs}
            </button>
          </div>
        </div>
      } */}

      {/* {location?.pathname === "/dashboard-manager" && isToggle && (
        <div className=''>
          <button
            className='w-25 btn btn-outline-success mb-2'
            style={{ fontWeight: "bold", margin: "0 0 0 120px" }}
            onClick={handleViewAllTransaction}
          >
            {language.view_all_transaction}
          </button>
        </div>
      )}

      {location?.pathname === "/dashboard-manager" && !isToggle && (
        <div className=''>
          <button
            className='w-25 btn btn-outline-success mb-2'
            style={{ fontWeight: "bold", margin: "0 0 0 120px" }}
            onClick={handleViewAllBalance}
          >
            {language.view_all_balance}
          </button>
        </div>
      )} */}
      <div className="container-fluid">
        {location?.pathname === "/dashboard-manager" && (
          <div className="task_head">
            Dashboard Manager
            <div
              className="menu-bar-wrp"
              style={{
                cursor: "ponter",
              }}
              onClick={() => setOpenMenu((prev) => !prev)}
            >
              <img src={hamburger} alt="" />
              {openMenu && (
                <div className="menu-box-hm">
                  <p onClick={() => navigate("/eventsCalender/true")}>
                    Calendar
                  </p>
                  <p onClick={() => navigate("/eventsCalender/toggle5")}>
                    Risk management
                  </p>
                  <p>Prediction/Forecasting</p>
                  <p>Budget & financials</p>
                  <p>Chat monitor</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div
        className="container-fluid"
        style={{
          // border:'4px solid #fff',
          padding: "0px 30px",
          borderRadius: "25px",
          marginBottom: "30px",
          marginTop: "0px",
        }}
      >
        <Managebtn getTime={getTime} value={time} />
        <div className="chart-slide">
          <div className="">
            {location?.pathname !== "/dashboard-manager" &&
              openAccReceive7 &&
              profileData &&
              (profileData.userType === "Business" || "Personal") && (
                <div className="container">
                  {<DashboardChartFive time={time} />}
                </div>
              )}
            {location?.pathname !== "/dashboard-manager" &&
              expensePerLineGraph7 &&
              dashboardThreeData &&
              Object.keys(dashboardThreeData).length > 0 && (
                <>
                  <div
                    className="adjust-two-chart"
                    style={{
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      className="donut_chart_div"
                      style={{
                        width: "100%",
                        minWidth: "100%",
                        maxWidth: "100%",
                      }}
                    >
                      <LineChartThree
                        data={Object.values(dashboardThreeData)}
                        time={time}
                        userType={profileData.userType}
                      />
                    </div>
                  </div>
                </>
              )}
            {location?.pathname !== "/dashboard-manager" &&
              expensePerBarGraph7 &&
              dashboardThreeData &&
              Object.keys(dashboardThreeData).length > 0 && (
                <>
                  <div
                    className="adjust-two-chart"
                    style={{
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      className="donut_chart_div extra_donut_height"
                      style={{
                        width: "100%",
                        minWidth: "100%",
                        maxWidth: "100%",
                      }}
                    >
                      <DashboardChartThree
                        data={Object.values(dashboardThreeData)}
                        time={time}
                        userType={profileData.userType}
                      />
                    </div>
                  </div>
                </>
              )}
            {location?.pathname !== "/dashboard-manager" &&
              (expenseBarChart7 ||
                expenseLineChart7 ||
                salesLineChart7 ||
                profitLineChart7) && (
                <div className="container">
                  {
                    <DashboardChartFour
                      time={time}
                      userCode={location?.state?.userRegCodr}
                      expenseBarChart={expenseBarChart7}
                      expenseLineChart={expenseLineChart7}
                      salesLineChart={salesLineChart7}
                      profitLineChart={profitLineChart7}
                    />
                  }
                </div>
              )}

            {location.pathname !== "/dashboard-manager" && currentTotalBar7 && (
              <div className="adjust-two-chart">
                <div className="col-12">
                  {dashboardOneData &&
                    Object.keys(dashboardOneData).length > 0 && (
                      <DashboardChartOne
                        data={Object.values(dashboardOneData)}
                        time={time}
                        userType={profileData.userType}
                        userCode={location?.state?.userRegCodr}
                      />
                    )}
                </div>
              </div>
            )}

            {location.pathname !== "/dashboard-manager" &&
              currentTotalLine7 && (
                <div className="adjust-two-chart">
                  <div style={{ width: "100%" }}>
                    {
                      // dashboardOneData2 &&
                      <AnimatedLineChart
                        data={dashboardOneData2}
                        time={time}
                        // userType={profileData.userType}
                        userCode={location?.state?.userRegCodr}
                        setSelectedOne={setSelectedOne}
                      />
                    }
                    {/* <AnimatedLineChart/> */}
                  </div>
                </div>
              )}

            {location.pathname !== "/dashboard-manager" &&
              currentActualVsBudgetLine7 && (
                <div className="adjust-two-chart">
                  <div>
                    {dashboardTwoData2 && (
                      <LineChartTwo
                        data={dashboardTwoData2}
                        time={time}
                        setSelectedTwo={setSelectedTwo}
                      />
                    )}
                  </div>
                </div>
              )}

            {location.pathname !== "/dashboard-manager" &&
              currentActualVsBudgetBar7 && (
                <div className="adjust-two-chart">
                  <div className="col-12">
                    {dashboardTwoData &&
                      Object.keys(dashboardTwoData).length > 0 && (
                        <DashboardChartTwo
                          data={Object.values(dashboardTwoData)}
                          time={time}
                          userType={profileData.userType}
                          userCode={location?.state?.userRegCodr}
                        />
                      )}
                  </div>
                </div>
              )}

            {/* Transaction Dashboard */}
            {location.pathname !== "/dashboard-manager" &&
              transactionDashboard7 && (
                <div className="container mt-4">
                  <DashboardChartSixB
                    goToSelectedSlice={goToSelectedSlice}
                    time={time}
                    setDetailModal={setDetailModal}
                    setTransData={setTransData}
                    userCode={location?.state?.userRegCodr}
                  />
                </div>
              )}
            {location?.pathname !== "/dashboard-manager" &&
              balanceDashboard7 && (
                <div className="container mt-4">
                  <DashboardChartSix
                    goToSelectedSlice={goToSelectedSlice}
                    time={time}
                    userCode={location?.state?.userRegCodr}
                  />
                </div>
              )}

            {location?.pathname !== "/dashboard-manager" &&
              (taxLineGraph7 || taxPieGraph7) && (
                <div>
                  <DashboardChartSeven
                    time={time}
                    location={location}
                    taxLineGraph={taxLineGraph7}
                    taxPieGraph={taxPieGraph7}
                  />
                </div>
              )}

            {location?.pathname === "/dashboard-manager" && (
              <Slider {...settings} ref={slideRef}>
                <div>
                  <Dashboardzerotwo
                    setZeroDate={setZeroDate}
                    zeroDate={zeroDate}
                    dashboardZeroData={dashboardZeroData}
                    setDashbardZeroData={setDashbardZeroData}
                    dashBoardZeroTaskData={dashBoardZeroTaskData}
                    setTime={setTime}
                    time={time}
                    userCode={location?.state?.userRegCodr}
                  />
                </div>

                <div>
                  <div
                  // className="row justify-content-md-center"
                  >
                    {/* one */}
                    <div className="adjust-two-chart">
                      <div className="col-sm-12 col-md-6 mt-4">
                        {dashboardOneData &&
                          Object.keys(dashboardOneData).length > 0 && (
                            <DashboardChartOne
                              data={Object.values(dashboardOneData)}
                              time={time}
                              userType={profileData.userType}
                              userCode={location?.state?.userRegCodr}
                            />
                          )}
                      </div>
                      <div style={{ width: "100%" }}>
                        {dashboardOneData2 && (
                          <AnimatedLineChart
                            data={dashboardOneData2}
                            time={time}
                            // userType={profileData.userType}
                            userCode={location?.state?.userRegCodr}
                            setSelectedOne={setSelectedOne}
                          />
                        )}
                        {/* <AnimatedLineChart/> */}
                      </div>
                    </div>
                    {/* two */}
                    <div className="adjust-two-chart">
                      <div>
                        {dashboardTwoData2 && (
                          <LineChartTwo
                            data={dashboardTwoData2}
                            time={time}
                            setSelectedTwo={setSelectedTwo}
                          />
                        )}
                      </div>
                      <div className="col-sm-12 col-md-6 mt-4">
                        {dashboardTwoData &&
                          Object.keys(dashboardTwoData).length > 0 && (
                            <DashboardChartTwo
                              data={Object.values(dashboardTwoData)}
                              time={time}
                              userType={profileData.userType}
                              userCode={location?.state?.userRegCodr}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* three */}
                <div className="container mt-4">
                  {dashboardThreeData &&
                    Object.keys(dashboardThreeData).length > 0 && (
                      <>
                        <div className="adjust-two-chart">
                          <div className="donut_chart_div extra_donut_chart">
                            <DashboardChartThree
                              data={Object.values(dashboardThreeData)}
                              time={time}
                              userType={profileData.userType}
                            />
                          </div>
                          <div className="donut_chart_div">
                            <LineChartThree
                              data={Object.values(dashboardThreeData)}
                              time={time}
                              userType={profileData.userType}
                            />
                          </div>
                        </div>
                      </>
                    )}
                </div>

                {/* four */}
                <div className="container">
                  {
                    <DashboardChartFour
                      time={time}
                      userCode={location?.state?.userRegCodr}
                    />
                  }
                </div>

                {/* five */}
                {profileData && profileData.userType === "Business" && (
                  <div className="container">
                    {<DashboardChartFive time={time} />}
                  </div>
                )}

                {/* integration manager / six*/}
                <div className="container mt-4">
                  <DashboardChartSix
                    goToSelectedSlice={goToSelectedSlice}
                    time={time}
                    userCode={location?.state?.userRegCodr}
                  />
                </div>

                {/* integration manager / six B*/}
                <div className="container mt-4">
                  <DashboardChartSixB
                    goToSelectedSlice={goToSelectedSlice}
                    time={time}
                    setDetailModal={setDetailModal}
                    setTransData={setTransData}
                    userCode={location?.state?.userRegCodr}
                  />
                </div>

                {/* Book keepers / seven */}
                <div>
                  <DashboardChartSeven
                    time={time}
                    location={location}
                    taxLineGraph={taxLineGraph7}
                    taxPieGraph={taxPieGraph7}
                  />
                </div>
              </Slider>
            )}
          </div>
        </div>
      </div>

      {detailModal && (
        <IntegrationBankDeailModal
          closeModal={(e) => {
            // e.stopPropagation()
            setDetailModal(false);
          }}
          filteredData={transData}
        />
      )}
    </div>
  );
}

export default DashboardManager7;
